export default __webpack_public_path__ + "img/InterDisplay-Italic_47d463d.woff2";